// @flow
import gql from 'graphql-tag'
import { type Handbook, HANDBOOK_FIELDS_FRAGMENT } from 'gql/handbook'

export const SCHOOL_WITH_HANDBOOK_FIELDS_FRAGMENT = gql`
  fragment SchoolWithHandbookFields on School {
    handbook {
      ...HandbookFields
    }
  }
  ${HANDBOOK_FIELDS_FRAGMENT}
`

export type SchoolWithHandbook = {
  handbook: Handbook | null,
}
